module.exports = __webpack_public_path__ + "static/img/7.f6a38c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurante/7.jpg
// module id = oX7i
// module chunks = 1